import { Link, makeStyles, SvgIcon, SvgIconProps, Typography } from "@material-ui/core"
import React from "react"

const useStyles = makeStyles(theme => ({
  link: {
    display: "inline-flex",
    alignItems: "center"
  },
  linkIcon: {
    marginBottom: 2,
    marginLeft: 4
  }
}))
const BlockRenderer = props => {
  const { style = "normal" } = props.node

  if (/^h\d/.test(style)) {
    return <Typography variant={style}>{props.children}</Typography>
  }

  if (style === "blockquote") {
    return <blockquote>- {props.children}</blockquote>
  }
  // Fall back to default handling
  // return BlockContent.defaultSerializers.types.block(props)
  return (
    <Typography variant="body1" paragraph>
      {props.children}
    </Typography>
  )
}

const link = ({mark: {href }, children}) => {
  const classes = useStyles();
  return (
    <Link href={href} rel="noreferrer" target="_blank" className={classes.link}>
      <span>{children}</span>

      <ExternalLinkIcon fontSize="small" className={classes.linkIcon}/>
    </Link>
  )
};

const blockContentserializer = {
  types: {
    block: BlockRenderer,
    // span: props => <div>span</div>,
  },
  marks: {
    link
  }
}
export default blockContentserializer

const ExternalLinkIcon = (props: SvgIconProps) => <SvgIcon {...props}>
  <path d="M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19Z"/>
</SvgIcon>